<template>
    <sky-select :disabled="disabled" autofocus filterable remote clearable :props="props" @change="change"
                :options="options" v-model="serviceCode" :placeholder="placeholder"
                :remote-method="getOptions"></sky-select>
</template>
<script>
import skySelect from '@/components/iglobalwin/formComponents/sky-select.vue'
import dict from '@/backend/services/dictionary/dictionary'

export default {
  name: 'serviceCode',
  props: {
    defaultKey: String,
    value: [String, Array, Object],
    disabled: Boolean
  },
  components: {
    skySelect
  },
  data() {
    return {
      filterable: true,
      remote: true,
      placeholder: '关联订单编号',
      options: [],
      props: {
        label: 'value',
        value: 'id'
      },
      serviceCode: this.value
    }
  },
  computed: {},
  watch: {
    value: function(val) {
      this.serviceCode = val
    },
    defaultKey(val) {
      this.getOptions(val)
    }
  },
  mounted() {
    this.serviceCode = this.value
    if (this.defaultKey) {
      this.getOptions(this.defaultKey)
    }
  },
  methods: {
    getOptions: function(val) {
      dict.getCustomerName({ name: val }).then(val => {
        this.options = val.data
      })
    },
    change(val) {
      let item = this.options.find(item => item.id === val)
      this.$emit('input', this.serviceCode)
      this.$emit('change', item || {})
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
